__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/dfe8e30/_next/";